<div class="py-2 px-4">
  @if (isLoading) {
    <div class="w-100 d-flex justify-content-center">
      <div class="spinner-border custom-spinner"
        role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  }
  @if (!isLoading) {
    <div>
      @if (hasUserReserved) {
        <div
          class="h-min text-sm w-100 flex flex-column justify-content-center align-items-center mb-2">
          <strong>{{ 'event.reservation-confirmed' | translate }}</strong>
          <div class="flex flex-row items-center gap-1 justify-content-center">
            <button (click)="openModal()"
              class="custom-color text-sm py-2 px-3 rounded-full">
              {{ 'event.cancel-event-button' | translate }}
            </button>
          </div>
        </div>
      } @else {
        @if (isBookable) {
          <div class="d-flex justify-content-center">
            <button (click)="openModal()" class="custom-color text-sm py-2 px-3 rounded-full w-50">
              <div class="flex justify-content-center">
                <b>{{ 'event.book-event-button' | translate }}</b>
              </div>
            </button>
          </div>
        }
        @if (!isBookable) {
          <div class="d-flex justify-content-center">
            <button disabled class="disabled custom-color text-sm py-2 px-3 rounded-full w-50">
              <div class="flex justify-content-center">
                <b>{{ 'event.not-bookable-event-button' | translate }}</b>
              </div>
            </button>
          </div>
        }
      }
    </div>
  }
</div>

<xplorer-bowser-reservation-popup
  [toggle]="toggleModal"
  [xploreItem]="xploreItem"
  [alreadyReserved]="hasUserReserved"
  (reservationConfirmed)="onReservationEvent()"
  >
</xplorer-bowser-reservation-popup>


